import React from 'react';
import PropTypes from 'prop-types';

const SoundOn = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={27.3} height={19.8} viewBox="0 0 27.3 19.8" {...props}>
    <path
      fill={props.color ?? '#224251'}
      d="M15.9.6c-.1-.2-.3-.4-.6-.5-.2-.1-.5-.1-.8 0L5 4.4H1c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h4l9.6 4.3c.1.1.3.1.4.1.6 0 1-.4 1-1V1c0-.1 0-.3-.1-.4zM4.2 13.9H1.5v-8h2.8v8h-.1zm10.3 4.2-8.8-4V5.7l8.8-4v16.4z"
    />
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M24.6 2.2c2.7 5.1 2.5 10.2 0 15.3M22.1 5c1.7 3.3 1.6 6.5 0 9.7m-2.6-6.4c.6 1.1.5 2.2 0 3.2"
    />
  </svg>
);

SoundOn.propTypes = {
  color: PropTypes.string
};

export default SoundOn;
